import { render, staticRenderFns } from "./add-edit.vue?vue&type=template&id=7206863f&scoped=true"
import script from "./add-edit.vue?vue&type=script&lang=js"
export * from "./add-edit.vue?vue&type=script&lang=js"
import style0 from "./add-edit.vue?vue&type=style&index=0&id=7206863f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7206863f",
  null
  
)

export default component.exports